import api from 'common/api';

export const getHblAPI = (params: any) => api.get('/hbl-status/list', params);

export const getHblDetailAPI = (params: any) => api.get('/hbl-status/detail', params);

export const updateHblAPI = (params: any) => api.put('/hbl-status', params);

export const updateHblListAPI = (params: any) => api.put('/hbl-status/update', params);

export const getHblDocDetailAPI = (params: any) => api.get('/hbl-status/document/detail', params);

export const uploadHblDocAPI = (params: any) => api.post('/hbl-status/document/upload', params);

export const deleteHblDocAPI = (params: any) => api.put('/hbl-status/document/delete', params);

export const validationHblDocAPI = (params: any) => api.get('/hbl-status/document/validation', params);

export const uploadPortcastInfoAPI = (params: any) => api.post('/hbl-status/portcast/update', params);

export const DOWNLOAD_EXCEL_HBL = '/hbl-status/list';

export const DOWNLOAD_EXCEL_PORTCAST_ERROR_LIST = '/hbl-status/portcast/getErrorList';
